import { FunctionComponent } from 'react';
import withRouter, { WithRouterProps } from 'next/dist/client/with-router';
import {
  ClientRouter as AppBridgeClientRouter,
  useRoutePropagation,
} from '@shopify/app-bridge-react';

const ClientRouter: FunctionComponent<WithRouterProps> = ({ router }) => {
  useRoutePropagation(router.asPath);
  return <AppBridgeClientRouter history={router} />;
};

export default withRouter(ClientRouter);
